// 带有 放大镜 基础搜索框
/* eslint-disable */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Input } from 'antd'
import { handleControl } from './control'
import { renderLabelString } from '@/utils/renderUtils'

const Search = Input.Search
const I2Search = (props) => {
  const {
    propsClassName, propsClassSpan, style,// 样式 className
    modalProps, label, ending, // 组件 功能参数
    options, query, value, searchKey, // 组件 数据源
    clearKey, killPending, reduxObj,// 请求相关控制数据
    action, actionChange, resAction, headerchange, onSearch // 请求方法
  } = props

  const handleValue = Object.keys(query).includes(searchKey)
    ? query[searchKey]
    : ''
   // 初始化Tag选择状态
  const [ useValue, setUseValue ] = useState(handleValue)
  useEffect(() => {
    setUseValue(handleValue)
  }, [query.refQ, query[searchKey]])
 
  const changeSearch = (e) => {
    setUseValue(e.target.value)
    handleControl(
      {
        ...props,
        action: () => {} // onChange 不触发 action 请求
      },
      { [searchKey]: e.target.value }
    )
  }
  const handleSearch = (e) => {
    // ----- 提交组件 -----------
    handleControl(
      props,
      { [searchKey]: e }
    )
  }
  return (
    <div className={propsClassName}>
      <span className={propsClassSpan} style={{ marginRight: '-2px' }}>{renderLabelString(label)}</span>
      <Search
        // -- modalProps
        allowClear={true}
        placeholder={`请填写${label}`}
        style={style}
        enterButton={true}
        {...modalProps}
        // ---
        value={useValue}
        onChange={changeSearch}
        onSearch={handleSearch}
      />
    </div>

  )
}

export default I2Search

I2Search.defaultProps = {
  propsClassName: 'mode',
  propsClassSpan: '',
  style: { width: 240 },
  modalProps: {},
  query: {},
  options: [],
  killPending: false,
  radio: false // 是否单选
}

// props.onSearch => <Search 组件监听回车 调用事件